"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDisplayTagDto = void 0;
class UpdateDisplayTagDto {
    /**
     * @deprecated Use `name` instead.
     */
    title;
    /**
     * @deprecated
     */
    description;
    name;
    pricingMultiplier;
}
exports.UpdateDisplayTagDto = UpdateDisplayTagDto;
